app.bind('default', function (context) {
    const $menu = $('[js-toggle-menu]', context);
    const $header = $('[js-header]', context);
    const $headerLink = $('[js-header-menu-link]', context);
    const $headerMenu = $('[js-header-menu]', context);
    const $window = $(window);
    $menu.on('click', function () {
        $menu.add($headerMenu).add($header).toggleClass('is-open')
    });
    $menu.on('close', () => {
        $menu.add($headerMenu).add($header).removeClass('is-open')
    });

    $headerLink.on('click.menu', function () {
        $menu.trigger('close')
    });

    $window.on('resize', () => {
        if ($window.width() > 1000) {
            $menu.trigger('close')
        }
    })
});
